<div class="drawer-container h-100 d-flex flex-column shadow">
  <div class="drawer-header p-4 bg-white border-bottom d-flex justify-content-between align-items-center">
    <h5 class="mb-0">Review Detail</h5>
    <button type="button" class="btn-close text-dark" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="drawer-body p-4 flex-grow-1 overflow-auto bg-light">
    <!-- Review Section -->
    <div class="card mb-4 border-0 shadow-sm">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h4 class="text-warning mb-0 font-weight-bolder">{{ review.rating }} ★</h4>
          <span class="text-xs text-secondary">{{ review.createTime | date:'medium' }}</span>
        </div>
        <h6 class="mb-1">{{ review.reviewerName }}</h6>
        <p class="text-sm text-dark mb-0">{{ review.comment || '(No comment left by user)' }}</p>
      </div>
    </div>

    <!-- Status Section -->
    <div class="row mb-4">
      <div class="col-6">
        <p class="text-xs text-secondary mb-1">Reply Status</p>
        <span class="badge badge-sm" 
          [ngClass]="{
            'bg-gradient-info': review.reply?.status === 'draft',
            'bg-gradient-warning': review.reply?.status === 'approved',
            'bg-gradient-success': review.reply?.status === 'published',
            'bg-gradient-secondary': !review.reply?.status || review.reply?.status === 'none'
          }">
          {{ review.reply?.status || 'none' | uppercase }}
        </span>
      </div>
      <div class="col-6" *ngIf="action">
        <p class="text-xs text-secondary mb-1">Action State</p>
        <span class="badge badge-sm bg-gradient-dark">{{ action.state | uppercase }}</span>
      </div>
    </div>

    <!-- Reply Section -->
    <div class="card border-0 shadow-sm" *ngIf="action; else noAction">
      <div class="card-header bg-white border-bottom py-3">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0 text-sm">Reply Draft</h6>
          <span class="badge bg-light text-dark text-xs">{{ action.priority }}</span>
        </div>
      </div>
      <div class="card-body">
        <textarea 
          class="form-control text-sm font-weight-normal" 
          rows="10" 
          [(ngModel)]="replyText"
          [disabled]="action.state !== 'pending_approval' && action.state !== 'open'"
          placeholder="Write or edit reply here...">
        </textarea>
        
        <div class="mt-3 text-xs text-secondary" *ngIf="action.payloadDraft?.modelInfo">
          Model: {{ action.payloadDraft.modelInfo.modelName || 'Unknown' }}
        </div>
      </div>
    </div>
    
    <ng-template #noAction>
      <div class="alert alert-secondary text-xs text-white" role="alert">
        No reputation action associated with this review yet.
      </div>
    </ng-template>
  </div>

  <div class="drawer-footer p-4 bg-white border-top text-end" *ngIf="action">
    <div class="d-flex justify-content-between w-100">
      <div>
        <button class="btn btn-outline-secondary btn-sm me-2" (click)="skip()" *ngIf="action.state === 'pending_approval'">Skip</button>
        <button class="btn btn-outline-warning btn-sm" (click)="regenerate()" *ngIf="action.state === 'pending_approval'">Regenerate</button>
      </div>
      <div>
        <button class="btn btn-danger btn-sm me-2" (click)="reject()" *ngIf="action.state === 'pending_approval'">Reject</button>
        <button class="btn btn-primary btn-sm" (click)="approve()" *ngIf="action.state === 'pending_approval'">Approve & Sync</button>
      </div>
    </div>
  </div>
</div>
